import { createRequestState } from "./learnerDashboardModel";
import { ACCESS_CLEARED } from "../../../redux/reducers/accessReducer";

export const LEARNER_WORKSPACE_OPENED = "unityLearner/workspaceOpened";
export const LEARNER_WORKSPACE_CLOSED = "unityLearner/workspaceClosed";
export const LEARNER_FIELD_CHANGED = "unityLearner/fieldChanged";
export const LEARNER_SHELL_REQUESTED = "unityLearner/shellRequested";

export const createLearnerDashboardState = () => ({
  sessionId: null,
  scopeKey: null,
  shellState: createRequestState("loading"),
  navigationState: createRequestState(),
  progressState: createRequestState(),
  assessmentState: createRequestState(),
  engagementState: createRequestState(),
  trackingState: createRequestState(),
  calendarState: createRequestState(),
  certificateState: createRequestState(),
  accountState: createRequestState(),
  programmeProgressState: {},
  activeIntakeId: "",
  hasProgrammeSelection: false,
});

const initialState = createLearnerDashboardState();
const fields = new Set(Object.keys(initialState).filter((key) =>
  key !== "sessionId" && key !== "scopeKey"));

// Only the mounted, verified learner workspace may publish into this branch.
// Session ownership also rejects late responses after leaving and re-entering
// the same tenant/account. No learner records are persisted by this reducer.
export default function learnerDashboardReducer(state = initialState, { type, payload } = {}) {
  if (type === ACCESS_CLEARED) return createLearnerDashboardState();
  if (type === LEARNER_WORKSPACE_OPENED && payload?.sessionId) {
    return { ...createLearnerDashboardState(), sessionId: payload.sessionId, scopeKey: payload.scopeKey };
  }
  if (!state.sessionId || state.sessionId !== payload?.sessionId) return state;
  if (type === LEARNER_WORKSPACE_CLOSED) return createLearnerDashboardState();
  if (type === LEARNER_SHELL_REQUESTED) {
    return { ...createLearnerDashboardState(), sessionId: state.sessionId, scopeKey: state.scopeKey };
  }
  if (type === LEARNER_FIELD_CHANGED && fields.has(payload.field)) {
    if (state[payload.field] === payload.value) return state;
    return { ...state, [payload.field]: payload.value };
  }
  return state;
}

export const selectUnityLearner = (state) => state.unityLearner;
export const selectLearnerShell = (state) => selectUnityLearner(state).shellState;
export const selectLearnerProgress = (state) => selectUnityLearner(state).progressState;
export const selectLearnerActiveIntakeId = (state) => selectUnityLearner(state).activeIntakeId;
